<template>
  <div class="authority-distribute-route">
    <div class="header">
      <el-input v-model="filterKey"
                size="mini"
                placeholder="筛选权限路径"
                clearable>
      </el-input>
    </div>
    <div class="main">
      <div class="main-cont">
        <AppScrollbar style="height: 100%">
          <el-tree ref="routeTree"
                   :data="routeTreeList"
                   :default-checked-keys="distributes"
                   node-key="id"
                   :filter-node-method="filterNodes"
                   :props="defaultProps"
                   empty-text="没有可分配的权限路径"
                   expand-on-click-node
                   show-checkbox
                   check-strictly>
            <template #default="{node, data}">
              <span class="custom-tree-node">
                <i class="iconfont icon-info"></i>
                <span>{{node.label}}</span>
              </span>
            </template>
          </el-tree>
        </AppScrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import AppScrollbar from '../../elements/AppScrollbar'
export default {
  name: 'AuthorityDistributeRoute',
  components: {
    AppScrollbar
  },
  props: {
    routeList: {
      type: Array,
      required: true
    },
    distributes: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    routeTreeList: function () {
      return this.routeList
    }
  },
  data () {
    return {
      filterKey: '',
      defaultProps: {
        label: 'name',
        children: 'children'
      }
    }
  },
  methods: {
    filterNodes (value, data) {
      return !value || data.name.includes(value)
    },
    selectAll () {
      let routeTree = this.$refs.routeTree
      if (routeTree) {
        let routeList = this.routeList
        if (routeList) {
          let routeIds = routeList.map(route => route.id)
          routeTree.setCheckedKeys(routeIds)
        }
      }
    },
    clearSelection () {
      let routeTree = this.$refs.routeTree
      if (routeTree) {
        routeTree.setCheckedKeys([])
      }
    },
    getDistributeRoutes () {
      return new Promise((resolve, reject) => {
        let checkedNodes = this.$refs.routeTree.getCheckedNodes()
        let getSelection = checkedNodes.map(value => value.id)
        let distributes = this.distributes || []
        let addIds = []
        getSelection.forEach(value => {
          if (!distributes.includes(value)) {
            addIds.push(value)
          }
        })
        let deleteIds = []
        distributes.forEach(value => {
          if (!getSelection.includes(value)) {
            deleteIds.push(value)
          }
        })
        if (!addIds.length && !deleteIds.length) {
          reject(new Error('权限路径分配未变化'))
        } else {
          resolve({addIds, deleteIds})
        }
      })
    }
  },
  watch: {
    routeList: function () {
      this.filterKey = ''
    },
    filterKey: function (val) {
      this.$refs.routeTree.filter(val)
    }
  }
}
</script>

<style lang="scss">
  .authority-distribute-route {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      padding: 10px;
      .el-input {
        .el-input__inner {
          border-radius: 20px;
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .el-tree {
          min-height: 150px;
          background-color: transparent;
          .el-tree-node {
            & > .el-tree-node__content {
              height: 28px;
              & > .el-checkbox {
                &.is-disabled {
                  display: none;
                }
              }
            }
          }
          .el-tree__empty-block {
            min-height: 150px;
            & > .el-tree__empty-text {
              font-size: 12px;
            }
          }
          .custom-tree-node {
            color: #303133;
            font-size: 13px;
            padding-right: 10px;
            i {
              font-size: 14px;
              vertical-align: -1px;
            }
          }
        }
      }
    }
  }
</style>
